import React, { useContext } from 'react';
import useTimerCallPageStyles from './styles';
import PageContext from '../../contexts/pageContext';
import Countdown from 'react-countdown';
import Button from '../../components/button';

const TimerAndCall = ({ sectionData, extraProps = {} }) => {
  const { isMobile, fullPageData } = useContext(PageContext);
  const [nodeData] = sectionData?.components;
  const classes = useTimerCallPageStyles({ isMobile });

  const CounterBox = ({ value, text }) => {
    return (
      <div className={classes.counterBox}>
        <div>{value}</div>
        <div>{text}</div>
      </div>
    );
  };

  const renderer = ({ formatted, completed }) => {
    return (
      <div className={classes.countdown}>
        <CounterBox value={formatted?.hours} text="Hours" />
        <CounterBox value={formatted?.minutes} text="Mins" />
        <CounterBox value={formatted?.seconds} text="Secs" />
      </div>
    );
  };

  const CountDownJSX = (offerPriceValidFor) => {
    let conversions = extraProps?.conversions || 0;
    if (offerPriceValidFor && offerPriceValidFor - conversions <= 0) {
      return null;
    }
    return (
      <div className={classes.offerWrapper}>
        <div className={classes.offerEndsTitle}>Offer ends in</div>
        <Countdown
          renderer={renderer}
          date={nodeData.offerCounter?.metadata?.endDate}
          daysInHours
        />
      </div>
    );
  };

  return (
    <section className={classes.timerAndCallSection}>
      <div className={classes.timerAndCallContainer}>
        <div className={classes.timerAndCallBox}>
          {/* offer title and countdown */}
          {nodeData?.showOffer?.metadata?.value &&
          nodeData.offerCounter?.metadata?.isOfferActive
            ? CountDownJSX(nodeData.offerCounter?.metadata?.offerPriceValidFor)
            : null}

          {/* title */}
          {nodeData?.title?.metadata?.value ? (
            <div className={classes.title}>
              <span
                ref={nodeData?.heading?.refSetter}
                dangerouslySetInnerHTML={{
                  __html: nodeData?.title?.metadata?.value
                }}
              />
            </div>
          ) : null}

          {nodeData?.timerButton?.metadata?.value ? (
            <Button
              style={{ width: '100%', fontWeight: '700', fontSize: '14px' }}
              data={{
                // link: 'headerData?.loginCtaLink',
                // isLink: 1,
                value: nodeData.timerButton.metadata.value
                // isExternal: 1
              }}
              onClick={extraProps?.courseBuyNow}
              type={'primary'}
              size={'medium'}
              target={null}
              name="button"
              rel={null}
              // styling={isMobile ? { margin: '0 40px' } : {}}
            />
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default TimerAndCall;
